<template>
  <div>
    <b-button v-b-modal.modalRapportJson>Importer rapport JSON à mon compte</b-button>
    <b-modal
      size="lg"
      hide-footer
      id="modalRapportJson"
      title="Importer JSON"
    >
      <b-row class="mb-2">
        <b-col sm="12">
          <b-card bg-variant="light">
            <!-- <b-form-group
              label="Mail"
              label-for="nested-diagnostic"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input v-model="mail" required></b-form-input>
            </b-form-group> -->
            <FileUpload
              name="jsonFile[]"
              :showUploadButton="false"
              :showCancelButton="false"
              :customUpload="true"
              @uploader="uploadeFile"
              :auto="true"
              accept=".json"
            >
              <template #empty>
                <p>Glisser/déposer le fichier ici.</p>
              </template>
            </FileUpload>

            <b-button
              :disabled="(!report) ? true : false"
              block
              class="mt-3 mb-3"
              type="submit"
              variant="primary"
              @click="saveReport()"
            >
              Importer
              <b-spinner small class="ml-3" v-if="isLoading"></b-spinner>
            </b-button>
      <b-alert :variant="variant" :show="success">{{ message }}</b-alert>

          </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ImportReportJsonComponent",
  data() {
    return {
      mail: "",
      report: null,
      disabled: false,
      isLoading: false,
      success: false,
      message: false,
      variant: 'info',
    };
  },
  components: {},
  mounted() {
    // this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
    //   if (modalId === "modalRapportJson") {
    //     this.getCategories();
    //   }
    // });
    // this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
    //   if (modalId === "modal-categories") {
    //     this.categories = [];
    //   }
    // });
  },
  methods: {
    saveReport() {
      this.isLoading = true;

      fetch(
        process.env.VUE_APP_API_BASE_URL + "/api/v1/report/saveReportByUserId",
        {
          method: "POST",
          body: JSON.stringify({ auditResults: this.report }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.localStorage.token}`,
          },
        }
      )
        // .then((res) => res.json())
        .then((rep) => {
          console.log(rep);
          this.isLoading = false;

          this.success = true;
          this.report = null;
          this.mail = "";

          if (rep.status === 200) {
            this.variant = "success";

            this.message = "Importé avec succès";
  this.$emit('getAllReports', true)

          } else {
            this.variant = "danger";

            this.message = "Erreur lors  de l'import";
          }
          setTimeout(() => {
            this.success = false;
          }, 6000);
        })
        .catch((error) => {
          this.message = error;
          console.error("There was an error!", error);
          this.isLoading = false;
          this.report = null;
        });
    },
    uploadeFile(event) {
      const value = event.files[0];
      const fileReader = new FileReader();

      fileReader.onload = (e) => {
        this.report = JSON.parse(e.target.result);
        const user = JSON.parse(localStorage.user)
     
        this.report.user.id = user.id;
        this.report.userId = user.id;
        this.report.user.email = user.email;

      };
      fileReader.readAsText(value);
    },
  },
};
</script>
<style></style>
